import  React, { useCallback, useMemo } from 'react'
import { useCookies } from 'react-cookie'

import { PermissionType } from '../../api/types'
import sidebarToggle from '../../assets/icons/sidebarToggle.svg'
import { useUser } from '../../contexts/User'

import styles from './Sidebar.module.scss'
import { SidebarItem } from './SidebarItem'


type SidebarItemProps = {
  permissionNeeded?: PermissionType,
  id?: string | number,
  icon: string,
  title: string,
  handler: () => void
}

type SideBarProps = {
  cookieName: string,
  isActiveChecker: (id: string | number) => boolean,
  beforeTopItems?: React.ReactNode,
  itemsTop: SidebarItemProps[],
  beforeBottomItems?: React.ReactNode,
  itemsBottom?: SidebarItemProps[]
  fixed?: boolean
}


export const Sidebar = ({
  cookieName,
  isActiveChecker,
  beforeTopItems,
  itemsTop,
  beforeBottomItems,
  itemsBottom,
  fixed
}: SideBarProps) => {
  const { hasPermissions } = useUser()
  const [cookies, setCookie] = useCookies([cookieName])


  const currentState = useMemo(() => {
    // eslint-disable-next-line i18next/no-literal-string
    return cookies[cookieName] || localStorage.getItem(cookieName) || 'opened'
  }, [cookies, cookieName])


  const isOpen = useMemo(() => {
    return currentState === 'opened'
  }, [currentState])


  const handleSidebarToggle = useCallback(() => {
    // eslint-disable-next-line i18next/no-literal-string
    const newState = isOpen ? 'closed' : 'opened'
    setCookie(cookieName, newState)
    localStorage.setItem(cookieName, newState)
  }, [isOpen, setCookie, cookieName])


  return (
    <div
      className={`
        ${styles.sidebarContainer}
        ${isOpen ? styles.opened : styles.closed}
        ${fixed && styles.fixed}
      `}
    >
      <button
        className={styles.sidebarToggleContainer}
        onClick={handleSidebarToggle}
      >
        <img
          className={styles.sidebarToggle}
          src={sidebarToggle}
          alt='sidebarToggle'
        />
      </button>
      <div className={styles.sidebarTop}>
        {beforeTopItems}
        {itemsTop.map(item => (
          (!item.permissionNeeded || hasPermissions(item.permissionNeeded)) && (
            <SidebarItem
              key={`sidebar_${cookieName}_top_item_${item.id}`}
              isActive={item.id ? isActiveChecker(item.id) : false}
              icon={item.icon}
              title={item.title}
              isOpen={isOpen}
              handler={item.handler}
            />
          )
        ))}
      </div>
      <div className={styles.sidebarBottom}>
        {beforeBottomItems}
        {itemsBottom && itemsBottom.map(item => (
          (!item.permissionNeeded || hasPermissions(item.permissionNeeded)) && (
            <SidebarItem
              key={`sidebar_${cookieName}_bottom_item_${item.id}`}
              isActive={item.id ? isActiveChecker(item.id) : false}
              icon={item.icon}
              title={item.title}
              isOpen={isOpen}
              handler={item.handler}
            />
          )
        ))}
      </div>
    </div>
  )
}

